/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query'
import Browser from '../Browser'
import { ComponentRenderer } from '../renderers/comp/fullComponents'
import { getEntryById } from '~/lib/contensis/misc'
// import Loader from '~/components/UI/General/Loader/Loader'

const FullLayout = ({ content }: any) => {
  const { data } = useQuery({
    queryKey: ['layout-full-ag', content?.component?.sys?.id],
    queryFn: async () => getEntryById(content?.component?.sys?.id || ''),
    enabled: !!content?.component?.sys?.id
  })

  // if (isLoading)
  //   return (
  //     <div className='py-l flex w-full justify-center'>
  //       <Loader fill={'#f5b6dc'} />
  //     </div>
  //   )
  // if (error) return <div>Error loading components</div>

  return (
    <>
      <Browser config={content}>
        {content?.component && data && (
          <ComponentRenderer components={data} contained={content?.contained} />
        )}
      </Browser>
    </>
  )
}

export default FullLayout
